export const FieldSchema = [
  {
    text: 'Number of Users',
    note: 'Note: Employees with a computer and mail/cloud storage account',
    name: ['numberOfUser', 'numberOfUserPrice'],
    placeholder: 'Enter the quantity',
    price: 10,
    isRequired: true
  },
  {
    text: 'Number of Additional Endpoints',
    note: 'Note: Additional computers/servers that do not have a single employee associated with the device',
    name: ['numberOfEndpoints', 'numberOfEndpointsPrice'],
    placeholder: 'Enter the quantity',
    price: 10,
    isRequired: true
  }
];
